'use strict';

module.exports = require('./components/inputs/Input').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/Input.js
// module id = 1804
// module chunks = 0